import { DeliverySetting } from "@/data/DeliverySetting.ts";
import { generateSignalDataAccess } from "@/react/utils/generateSignalDataAccess.ts";

export const [deliverySettings0, makeDeliverySettingsAvailable] = generateSignalDataAccess(DeliverySetting, { convertOpts: { autoSave: true } })

//@ts-ignore
window.deliverySettings0 = deliverySettings0